export default "__VITE_PUBLIC_ASSET__23d38c51__"